import styled from 'styled-components';
import Box from '@mui/material/Box';

export const InnerPanel = styled(Box)`
  background-color: #f5f5f5;
  padding: 10px;
`;
